/**
 * The cash-funded portion of a chip board — the amount that actually draws on the
 * player's wallet. Free-bet-covered chips (keyed by optionId in `appliedFreeBets`)
 * are paid by the reward, not the balance, so they're excluded.
 *
 * Used by the round-start auto-submit balance gate in `triggerSubmission` so a queued
 * free bet is never wrongly rejected as "insufficient balance" (which clears the chip
 * and skips the `/bet`). Mirrors the free-bet-excluding rebet gate in the `race_ready`
 * effect, the click-time guard, and the `isFreeBet` handling in useChipPlacementBetSubmit.
 *
 * When `appliedFreeBets` is empty (every cash-only board) this returns the exact sum
 * of chip amounts — identical to the previous `Σ chip.amount`, so cash bets are
 * unaffected.
 */
export function chargeableStake(
  chips: Record<string, { amount: number }>,
  appliedFreeBets: Record<string, unknown>
): number {
  return Object.entries(chips).reduce(
    (sum, [optionId, chip]) => sum + (appliedFreeBets[optionId] ? 0 : chip.amount),
    0
  )
}
